<template>
  <div class="wrapper">
    <div class="about-us-page">
      <section id="our-history" class="about-us-history history-section-space">
        <div class="container">
          <div class="row">
            <div class="our-focus-div col-sm-12">
              <div class="our-focus-img">
                <img src="/assets/images/os-images/about-us.png" alt="" width="1600" height="960" />
              </div>

              <div class="our-focus-boxes our-history col-sm-12">
                <div class="img-text">
                  <h3>Our History</h3>
                </div>
                <p>KIPS Education System, established over two decades ago, is one of Pakistan leading educational networks, known for its commitment to academic excellence and innovation. With a wide array of programs ranging from preschool to higher education, KIPS has consistently produced outstanding academic results and nurtured countless successful professionals. The institution prides itself on a student centric approach, offering a range of educational services, including test preparations, schooling, and distance learning.</p>
              </div>
              <div class="our-focus-boxes kips-os col-sm-12">
                <div class="img-text">
                  <h3>KIPS Online school</h3>
                </div>
                <p>KIPS Online School offers flexible, high-quality education through an innovative digital platform. Launched to provide accessible learning, it blends a comprehensive curriculum with interactive tools for self-paced, global education. Students benefit from real-time progress tracking, holistic development, and a home-schooling model that fosters academic and personal growth. KIPS Online School aims to create a dynamic and personalized learning experience, empowering students to excel in both their studies and life skills.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="msg-from-ceo" class="ceo-msg section-space">
        <div class="container">
          <div class="row">
            <div class="ceo-bg">
              <div class="ceo-img-div col-md-6 col-lg-4">
                <img src="/assets/images/os-images/ceo-image.png" alt="" width="400" height="471" />
              </div>
              <div class="ceo-text-div col-md-6 col-lg-8">
                <h3>Message from CE</h3>
                <p>At KIPS Education system, we envision education as the foundation for lifelong success. KIPS Online School embodies this vision by breaking barriers and redefining learning. Our platform ensures accessibility, flexibility, and excellence, enabling students to thrive in a fast-changing world. We are committed to nurturing minds, shaping futures, and empowering individuals with the skills to lead. Together, let’s embark on this journey toward holistic growth and boundless possibilities.</p>
                <strong>Chief Executive</strong>
                <span>KIPS Education System</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- <section class="featured-program section-space">
        <div class="container">
          <div class="row">
            <div class="headings">
              <h2><span class="featured-text">Featured</span> Program Offered</h2>
            </div>

            <div class="featured-program-div">
             
               <SsrCarousel
                loop
                :slides-per-page="3"
                :autoplay="true"
                :itemsToScroll="1"
                :paginate-by-slide="true"
                :autoplaySpeed="2000"
                :center-mode="false"
                show-dots
                :responsive="[
                  { maxWidth: 992, slidesPerPage: 2, itemsToScroll: 1 },
                  { maxWidth: 575, slidesPerPage: 1, itemsToScroll: 1 },
                ]"
              >
                <div class="slide">
                  <div class="card">
                    <img
                      src="/assets/images/os-images/course-one-image.png"
                      class="card-img-top"
                      alt="first-course"
                      width="320"
                      height="166"
                    />
                    <div class="card-body">
                      <div class="description">
                        <small class="subject">Pre-Engineering – Federal Board</small>
                        <strong class="card-title">Card Title</strong>
                        <small class="duration"
                          >Duration: <span class="period">One Year</span></small
                        >
                      </div>
                      <div class="course-card-detail">
                        <div class="all-items">
                          <span class="course-videos not-available">Videos</span>
                          <span class="course-readings">Readings</span>
                          <span class="course-quizes">Quizes</span>
                          <span class="course-assignments">Assignments</span>
                          <span class="course-lectures not-available">Live Lectures</span>
                        </div>
                      </div>
                    </div>
                    <a href="#" class="course-details-btn">Course Details</a>
                  </div>
                </div>

                <div class="slide">
                  <div class="card">
                    <img
                      src="/assets/images/os-images/course-two.png"
                      class="card-img-top"
                      alt="first-course"
                      width="320"
                      height="166"
                    />
                    <div class="card-body">
                      <div class="description">
                        <small class="subject">Pre-Engineering – Federal Board</small>
                        <strong class="card-title">Card Title</strong>
                        <small class="duration"
                          >Duration: <span class="period">One Year</span></small
                        >
                      </div>
                      <div class="course-card-detail">
                        <div class="all-items">
                          <span class="course-videos not-available">Videos</span>
                          <span class="course-readings">Readings</span>
                          <span class="course-quizes">Quizes</span>
                          <span class="course-assignments">Assignments</span>
                          <span class="course-lectures not-available">Live Lectures</span>
                        </div>
                      </div>
                    </div>
                    <a href="#" class="course-details-btn">Course Details</a>
                  </div>
                </div>

                <div class="slide">
                  <div class="card">
                    <img
                      src="/assets/images/os-images/course-three.png"
                      class="card-img-top"
                      alt="first-course"
                      width="320"
                      height="166"
                    />
                    <div class="card-body">
                      <div class="description">
                        <small class="subject">Pre-Engineering – Federal Board</small>
                        <strong class="card-title">Card Title</strong>
                        <small class="duration"
                          >Duration: <span class="period">One Year</span></small
                        >
                      </div>
                      <div class="course-card-detail">
                        <div class="all-items">
                          <span class="course-videos not-available">Videos</span>
                          <span class="course-readings">Readings</span>
                          <span class="course-quizes">Quizes</span>
                          <span class="course-assignments">Assignments</span>
                          <span class="course-lectures not-available">Live Lectures</span>
                        </div>
                      </div>
                    </div>
                    <a href="#" class="course-details-btn">Course Details</a>
                  </div>
                </div>

                <div class="slide">
                  <div class="card">
                    <img
                      src="/assets/images/os-images/course-one-image.png"
                      class="card-img-top"
                      alt="first-course"
                      width="320"
                      height="166"
                    />
                    <div class="card-body">
                      <div class="description">
                        <small class="subject">Pre-Engineering – Federal Board</small>
                        <strong class="card-title">Card Title</strong>
                        <small class="duration"
                          >Duration: <span class="period">One Year</span></small
                        >
                      </div>
                      <div class="course-card-detail">
                        <div class="all-items">
                          <span class="course-videos not-available">Videos</span>
                          <span class="course-readings">Readings</span>
                          <span class="course-quizes">Quizes</span>
                          <span class="course-assignments">Assignments</span>
                          <span class="course-lectures not-available">Live Lectures</span>
                        </div>
                      </div>
                    </div>
                    <a href="#" class="course-details-btn">Course Details</a>
                  </div>
                </div>

                <div class="slide">
                  <div class="card">
                    <img
                      src="/assets/images/os-images/course-three.png"
                      class="card-img-top"
                      alt="first-course"
                      width="320"
                      height="166"
                    />
                    <div class="card-body">
                      <div class="description">
                        <small class="subject">Pre-Engineering – Federal Board</small>
                        <strong class="card-title">Card Title</strong>
                        <small class="duration"
                          >Duration: <span class="period">One Year</span></small
                        >
                      </div>
                      <div class="course-card-detail">
                        <div class="all-items">
                          <span class="course-videos not-available">Videos</span>
                          <span class="course-readings">Readings</span>
                          <span class="course-quizes">Quizes</span>
                          <span class="course-assignments">Assignments</span>
                          <span class="course-lectures not-available">Live Lectures</span>
                        </div>
                      </div>
                    </div>
                    <a href="#" class="course-details-btn">Course Details</a>
                  </div>
                </div>

                <div class="slide">
                  <div class="card">
                    <img
                      src="/assets/images/os-images/course-two.png"
                      class="card-img-top"
                      alt="first-course"
                      width="320"
                      height="166"
                    />
                    <div class="card-body">
                      <div class="description">
                        <small class="subject">Pre-Engineering – Federal Board</small>
                        <strong class="card-title">Card Title</strong>
                        <small class="duration"
                          >Duration: <span class="period">One Year</span></small
                        >
                      </div>
                      <div class="course-card-detail">
                        <div class="all-items">
                          <span class="course-videos not-available">Videos</span>
                          <span class="course-readings">Readings</span>
                          <span class="course-quizes">Quizes</span>
                          <span class="course-assignments">Assignments</span>
                          <span class="course-lectures not-available">Live Lectures</span>
                        </div>
                      </div>
                    </div>
                    <a href="#" class="course-details-btn">Course Details</a>
                  </div>
                </div>

                <div class="slide">
                  <div class="card">
                    <img
                      src="/assets/images/os-images/course-two.png"
                      class="card-img-top"
                      alt="first-course"
                      width="320"
                      height="166"
                    />
                    <div class="card-body">
                      <div class="description">
                        <small class="subject">Pre-Engineering – Federal Board</small>
                        <strong class="card-title">Card Title</strong>
                        <small class="duration"
                          >Duration: <span class="period">One Year</span></small
                        >
                      </div>
                      <div class="course-card-detail">
                        <div class="all-items">
                          <span class="course-videos not-available">Videos</span>
                          <span class="course-readings">Readings</span>
                          <span class="course-quizes">Quizes</span>
                          <span class="course-assignments">Assignments</span>
                          <span class="course-lectures not-available">Live Lectures</span>
                        </div>
                      </div>
                    </div>
                    <a href="#" class="course-details-btn">Course Details</a>
                  </div>
                </div>
              </SsrCarousel>
            </div>

            <div class="btn-margin">
              <a class="purple-btn" href="#">Explore More</a>
            </div>
          </div>
        </div>
      </section> -->

      <section id="what-we-offer" class="features last-section-space">
        <div class="features-bg">
          <div class="container">
            <div class="">
              <div class="headings">
                <h2>What We Offer?</h2>
              </div>
              <div class="features-div">
                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/global.png" alt="Video 1" width="56" height="56" />
                  </div>
                  <h4>Global Accessibility</h4>
                  <p>Inclusive, worldwide learning with synchronous content, accommodating different time zones for maximum engagement.</p>
                </div>
                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/learning-flex.png" alt="Video 1" width="56" height="56" />
                  </div>
                  <h4>Learning Flexibility</h4>
                  <p>Adaptable schedules and lesson plans, allowing students to balance academics with personal commitments effectively.</p>
                </div>
                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/unbound-2.png" alt="Video 1" width="56" height="56" />
                  </div>
                  <h4>Unbound Virtual Learning Environment</h4>
                  <p>Provides unlimited access to high-quality resources, fostering creativity, innovation, and personalized growth.</p>
                </div>
                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/effective.png" alt="Video 1" width="56" height="56" />
                  </div>
                  <h4>Effective Parental Involvement</h4>
                  <p>Encourages parent engagement through reports, feedback, and scheduled meetings for student progress monitoring.</p>
                </div>
                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/home-schooling.png" alt="Video 1" width="56" height="56" />
                  </div>
                  <h4>Complete Model for Home Schooling</h4>
                  <p>A full homeschooling solution ensuring academic excellence and comprehensive student development.</p>
                </div>

                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/well-designed.png" alt="Video 1" width="56" height="56" />
                  </div>
                  <h4>Well-Designed and Pre-Scheduled Live Classes</h4>
                  <p>Structured, engaging sessions planned for interactive learning across global time zones.</p>
                </div>

                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/comprehensive.png" alt="Video 1" width="56" height="56" />
                  </div>
                  <h4>Comprehensive Individual Support for Self-Study</h4>
                  <p>Interactive resources, progress tracking, and feedback enhance independent learning and student success.</p>
                </div>

                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/holistic.png" alt="Video 1" width="56" height="56" />
                  </div>
                  <h4>Structured holistic development of students</h4>
                  <p>Focuses on moral, intellectual, physical, spiritual, and professional growth through diverse programs.</p>
                </div>

                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/per-counselling.png" alt="Video 1" width="56" height="56" />
                  </div>
                  <h4>Individualized Personal Counselling Sessions</h4>
                  <p>Personalized academic, emotional, and personal support to ensure student well-being and success.</p>
                </div>

                <div class="single-feat">
                  <div class="img-div">
                    <img src="/assets/images/os-images/pro-tracking.png" alt="Video 1" width="56" height="56" />
                  </div>
                  <h4>Progress Tracking and Timely Feedback Provisions</h4>
                  <p>Continuous student assessment through evaluations, reports, and constructive feedback for improvement.</p>
                </div>

                <div class="single-feat">
                  <div class="img-div">
                    <img
                      src="/assets/images/os-images/personlised-academic.png"
                      alt="Personalized Academic Assignments"
                      width="54"
                      height="54"
                    />
                  </div>
                  <h4>Personalized Academic Assignments</h4>
                  <p>
                    Students will receive personalized academic assignments tailored to
                    their individual learning needs, ensuring both academic excellence and
                    individualized growth.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- <section class="course-details section-space">
        <div class="container">
          <div class="row">
            <div class="content col-lg-7">
              <h2>Lower Secondary Program</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur. Volutpat volutpat tempus erat
                maecenas congue nam in. Orci euismod non turpis sapien tellus ipsum. Orci
                lobortis lacinia dui lacinia eget. Eget urna odio lectus sit sed donec.
                Tortor urna vel felis dictum faucibus est justo mi nisl. Egestas sed
                tempor semper augue at.
              </p>
              <h4>About this course</h4>
              <p>
                Designed to build a strong academic foundation while fostering critical
                thinking, creativity, and personal growth. The program bridges primary and
                higher education through interactive and engaging learning experiences.
              </p>
              <h4>Standard Features</h4>
              <ul>
                <li>Teacher with extensive qualification and experience.</li>
                <li>Focus on strengthening conceptual understanding.</li>
                <li>Frequent academic and career counseling sessions.</li>
                <li>Structured study plans and regular assessments.</li>
                <li>Regular practice aligned with Board Patterns.</li>
                <li>Full Syllabus Mock Exams</li>
              </ul>
              <h4>Course Features</h4>
              <div class="feature-item">
                <strong>Readings</strong>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet
                  Conseteture ipsum dolor.
                </p>
              </div>
              <div class="feature-item not-available">
                <strong>Leaderboard</strong>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet
                  Conseteture ipsum dolor.
                </p>
              </div>
              <div class="feature-item">
                <strong>Peer Assessment</strong>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet
                  Conseteture ipsum dolor.
                </p>
              </div>
              <div class="feature-item">
                <strong>Bookmark</strong>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet
                  Conseteture ipsum dolor.
                </p>
              </div>
              <div class="feature-item not-available">
                <strong>Teacher Support</strong>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet
                  Conseteture ipsum dolor.
                </p>
              </div>
              <div class="feature-item">
                <strong>Cooperative Staff</strong>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet
                  Conseteture ipsum dolor.
                </p>
              </div>
              <div class="feature-item">
                <strong>Extra-Curricular Activities</strong>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet
                  Conseteture ipsum dolor.
                </p>
              </div>
              <div class="feature-item">
                <strong>Notes</strong>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet
                  Conseteture ipsum dolor.
                </p>
              </div>
              <div class="feature-item">
                <strong>Videos</strong>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet
                  Conseteture ipsum dolor.
                </p>
              </div>
              <div class="feature-item">
                <strong>Stats</strong>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet
                  Conseteture ipsum dolor.
                </p>
              </div>
              <div class="feature-item">
                <strong>Live Classes</strong>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet
                  Conseteture ipsum dolor.
                </p>
              </div>
              <div class="feature-item">
                <strong>Search</strong>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet
                  Conseteture ipsum dolor.
                </p>
              </div>
              <div class="feature-item">
                <strong>Quizzes</strong>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet
                  Conseteture ipsum dolor.
                </p>
              </div>
              <div class="feature-item">
                <strong>Notification</strong>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet
                  Conseteture ipsum dolor.
                </p>
              </div>
            </div>
            <div class="subscription col-lg-4">
              <div class="card">
                <div class="sub-image-div">
                  <img
                    src="/assets/images/os-images/course-two.png"
                    class="card-img-top"
                    alt="first-course"
                    width="320"
                    height="166"
                  />
                </div>
                <div class="card-body">
                  <div class="course-price">
                    <small class="price-title">Course price</small>
                    <strong class="price-amount">Rs. 50,000</strong>
                    <small class="price-duration">90 Days Plan</small>
                    <div class="payment-btn">
                      <a class="purple-btn" href="#">Pay Now</a>
                    </div>
                    <div class="payment-btn">
                      <a class="white-btn" href="#">Free Trial</a>
                    </div>
                  </div>

                  <div class="course-includes">
                    <strong>This Course Include:</strong>
                    <div class="all-items">
                      <span class="course-videos not-available">Videos</span>
                      <span class="course-readings">Readings</span>
                      <span class="course-quizes">Quizes</span>
                      <span class="course-assignments">Assignments</span>
                      <span class="course-lectures not-available">Live Lectures</span>
                    </div>
                  </div>

                  <div class="payment-plan">
                    <strong>Payment Plan:</strong>
                    <div class="diff-plans">
                      <div>
                        <strong>Monthly</strong>
                        <span>(90 Days)</span>
                      </div>
                      <div>
                        <strong>Rs.50,000</strong>
                        <span class="cut-text">Rs. 10,000</span>
                      </div>
                    </div>

                    <div class="diff-plans">
                      <div>
                        <strong>Lump Sum</strong>
                        <span>(30 Days)</span>
                      </div>
                      <div>
                        <strong>Rs. 10,000</strong>
                        <span class="cut-text">Rs. 12,000</span>
                      </div>
                    </div>
                  </div>

                  <div class="course-info">
                  <p class="tick-content">Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet Conseteture  ipsum dolor.</p>
                  <p class="tick-content">Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet Conseteture  ipsum dolor.</p>
                  <p class="tick-content">Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet Conseteture  ipsum dolor.</p>
                  <p class="tick-content">Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet Conseteture  ipsum dolor.</p>
                  <p class="tick-content">Lorem ipsum dolor sit amet, consetetur sadips sedam adipscin Dolo Amet Conseteture  ipsum dolor.</p>
                  </div>

                  <div class="payment-btn-div">
                    <div class="payment-btn">
                      <a class="purple-btn" href="#">Pay Now</a>
                    </div>
                    <div class="payment-btn">
                      <a class="white-btn" href="#">Free Trial</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>  -->
    </div>
    <!-- <appFooter /> -->
  </div>
</template>

<script>
import SsrCarousel from "vue-ssr-carousel";
import "vue-ssr-carousel/index.css";
import pageHeader from "../components/pageHeader.vue";
import appFooter from "../layout/landing/appFooter.vue";

export default {
  components: {
    SsrCarousel,
    pageHeader,
    appFooter,
  },

  metaInfo: {
    title: "About Us | KIPS ONLINE SCHOOL",
    titleTemplate: "",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },

  mounted() {
    this.$nextTick(() => {
      const hash = window.location.hash;
      if (hash) {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        window.scrollTo(0, 0);
      }
    });
  },
};
</script>
